module.exports = __webpack_public_path__ + "img/img-card-how-work-2.624eddad.svg";